// extracted by mini-css-extract-plugin
export default {"ColorBlock":"ColorBlock_ColorBlock__nhjsR"};